import React from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'

import possessive from 'lib/possessive'
import Layout from 'components/Layout/SplitLayout'
import HeaderOne from 'components/Headers/HeaderOne'
import Text from 'components/Text'
import Loader from 'components/Loader'
import { ErrorText, Button } from 'components/Forms'

import style from './style.module.scss'

SuccessPetSafetyScreen.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
}

function SuccessPetSafetyScreen(props) {
  const { user, isLoading, error } = props

  if (isLoading) {
    return <Loader />
  }

  const { firstName, petCount } = user

  return (
    <Layout showNav={false}>
      {error ? (
        <ErrorText>{error}</ErrorText>
      ) : (
        <React.Fragment>
          <HeaderOne className={style.header}>
            The {pluralize(`pet`, petCount)} has been marked as safe.
          </HeaderOne>

          <Text className={style.text}>
            Thanks for taking the time to care for {possessive(firstName)}{' '}
            {pluralize(`pet`, petCount)}. Get in touch with them to arrange a
            time to safely return them.
          </Text>
          <Button href='https://www.petnotify.com/' target='_blank'>
            Learn more about Pet Notify
          </Button>
        </React.Fragment>
      )}
    </Layout>
  )
}

export default SuccessPetSafetyScreen
